import { formatFieldName } from "@/shared/text";

/**
 * What each known goal type is called on screen. The `goal_type` discriminator
 * is stable wire format, so a map is enough until the API supplies display
 * names. Add an entry when a new goal type ships.
 */
const GOAL_TYPE_LABELS: Record<string, string> = {
  dataset_summary: "Summarize the dataset",
  dataset_triage: "Triage the dataset",
  create_events: "Create events",
  session_summary: "Summarize the session",
  session_triage: "Triage the session",
};

/**
 * What a goal of this type is called on screen, wherever a goal is shown: the
 * agent editor, the agent's page, and a thread's goal chips. A type missing
 * from the map is humanized, so a newly shipped `new_custom_goal` reads
 * "New Custom Goal".
 */
export function goalTypeLabel(goalType: string): string {
  return GOAL_TYPE_LABELS[goalType] ?? formatFieldName(goalType);
}
